export const AI_INVENTORY_FORM_DRIVER_STEPS = [
  {
    element: '#ai-inventory-form-step-1',
    popover: {
      title: 'Tutorial do Formulário',
      description:
        'Bem-vindo ao <strong>cadastro manual</strong> de Inventário de IA! Se preferir um caminho mais rápido, você também pode cadastrar de forma <strong>guiada pela DAI</strong>. Use este tutorial sempre que precisar de ajuda para preencher o formulário.',
    },
  },
  {
    element: '#ai-inventory-form-step-2',
    popover: {
      title: 'Etapas do Formulário',
      description:
        'O formulário é dividido em <strong>4 etapas</strong>. Clique em qualquer aba para navegar entre elas a qualquer momento.',
    },
  },
  {
    element: '#ai-inventory-form-step-3',
    popover: {
      title: 'Etapa 1 — Informações Gerais',
      description:
        'Selecione qual <strong>Inteligência Artificial</strong> sua empresa utiliza e informe os <strong>departamentos</strong> onde ela é usada. Caso a IA não esteja na lista, escolha <strong>Outro</strong> para cadastrá-la manualmente.',
    },
  },
  {
    element: '#ai-inventory-form-step-4',
    popover: {
      title: 'Etapa 2 — Finalidade',
      description:
        'Registre <strong>para qual propósito</strong> a IA é utilizada — por exemplo: geração de conteúdo, análise de dados ou suporte ao cliente. Você pode adicionar múltiplas finalidades.',
    },
  },
  {
    element: '#ai-inventory-form-step-5',
    popover: {
      title: 'Etapa 3 — Detalhamento',
      description:
        'Informe se a IA <strong>processa dados pessoais</strong> e preencha os detalhes adicionais sobre o uso da ferramenta.',
    },
  },
  {
    element: '#ai-inventory-form-step-6',
    popover: {
      title: 'Etapa 4 — Resumo',
      description:
        'Confira todas as informações cadastradas antes de concluir. Você pode voltar a qualquer etapa para fazer ajustes.',
    },
  },
  {
    element: '#ai-inventory-form-step-7',
    popover: {
      title: 'Navegação',
      description:
        'Use os botões <strong>Voltar</strong> e <strong>Avançar</strong> para navegar entre as etapas. Ao avançar da primeira etapa, o registro é <strong>salvo automaticamente</strong>.',
    },
  },
]

export default AI_INVENTORY_FORM_DRIVER_STEPS
